// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__zYelq","spinner-c7wet2":"Loader_spinner-c7wet2__J1fOI"};